// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NCeqq","date":"styles_date__zHRr1","bottomScrollElem":"styles_bottomScrollElem__qAd1+","loaderContainer":"styles_loaderContainer__EBpv9"};